import { render } from "./error-message.vue?vue&type=template&id=243484ca"
import script from "./error-message.vue?vue&type=script&lang=js"
export * from "./error-message.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__